// extracted by mini-css-extract-plugin
module.exports = {"loader":"appLoader__loader___pf6RH"};